<template>
  <div>
    <PageTitle
      title="Guests"
      :btnCreate="true"
      :createRoute="'guests/add'"
      :permission="'Guest Create'"
    />

    <v-container fluid class="lighten-12 content">
      <!-- Page Title -->
      <v-card class="lighten-12 card-content">
        <TableFilters
          :filters="['status', 'search']"
          v-model="filter"
          :columns="columns"
        >
        </TableFilters>
      </v-card>

      <v-card class="mt-2">
        <v-container fluid class="light gray lighten-12">
          <!-- Data Table -->
          <v-row>
            <v-card-text class="pa-0">
              <v-data-table
                :items-per-page="paginationOptions.perPage"
                :fixed-header="true"
                :headers="headers"
                :items="customer"
                 item-key="id"
                hide-default-footer
              >
                <template v-slot:item.image="{ item }">
                  <v-dialog v-model="dialog" max-width="60vw">
                    <img
                      :src="loadimage"
                      alt=""
                      width="100%"
                      @click.stop="dialog = false"
                    />

                    <v-avatar size="32px" item color="primary"> </v-avatar>
                  </v-dialog>
                  <v-list-item class="px-0">
                    <v-list-item-avatar color="primary">
                      <img
                        v-if="item.image"
                        height="30"
                        width="30"
                        :src="item.image"
                        style="border-radius: 30%"
                        @mouseover.stop="dialog = true"
                        @mouseover="changeimage(item.image)"
                      />

                      <span
                        v-else
                        class="white--text subtitle-2 text-uppercase"
                        >{{ item.name.substring(0, 2) }}</span
                      >
                    </v-list-item-avatar>
                  </v-list-item>
                </template>
                <template v-slot:no-data>
                  <div class="mt-16 container justify-center item-center">
                    <img
                      style="height: 200px"
                      src="../../../assets/img/no-result.jpg"
                    />
                  </div>
                </template>

                <template v-slot:footer>
                  <pagination
                    @paginationOptions="setPaginationOptions"
                    @response="setResponseData"
                    url="hms/guests"
                    :filter="filter"
                    ref="pagination"
                  />
                </template>

                <template v-slot:item.is_active="{ item }">
                  <v-chip
                    :x-small="true"
                    class="ma-2"
                    label
                    text-color="white"
                    :color="getStatusColor(item.is_active)"
                    dark
                    >{{ item.is_active ? "Active" : "Archieved" }}</v-chip
                  >
                </template>

                <!-- Action -->
                <template v-slot:item.action="{ item }">
                  <list-menu
                    feature="guests"
                    :item="item"
                    viewPermission="Customer Show"
                    editPermission="Guest Edit"
                    softDeletePermission="Customer Soft Delete"
                    DeletePermission="Customer Soft Delete"
                    @refreshList="refreshData"
                  ></list-menu>
                </template>
              </v-data-table>
            </v-card-text>
          </v-row>
        </v-container>
      </v-card>
      <!-- </v-card> -->
      <div class="d-flex justify-center align-center"></div>
    </v-container>
  </div>
</template>

<script>
import { required, email, max } from "vee-validate/dist/rules";
import pagination from "../../shared/components/pagination";
import confirmation from "../../shared/components/confirmation";

import { Guest } from "../../../models/Guest";

import _ from "lodash";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";
import TableFilters from "@/components/base/TableFilters";
extend("required", {
  ...required,
  message: "{_field_} is required",
});

extend("max", {
  ...max,
  message: "{_field_} may not be greater than {length} characters",
});

extend("email", {
  ...email,
  message: "Email must be valid",
});

export default {
  data: () => ({
    loadimage: "",
    dialog: false,
    paginationOptions: {},
    expanded: [],
    singleExpand: false,
    pagination1: {
      descending: true,
      page: 1,
      rowsPerPage: 2,

      sortBy: "fat",
      totalItems: 0,
      rowsPerPageItems: [1, 2, 4, 8, 16],
    },

    pagination: {
      page: 1,
      itemsPerPage: 2,
    },
    page: 1,
    status: [
      { text: "Active", value: "active" },
      { text: "Archived", value: "archived" },
    ],
    columns: [
      {
        text: "Image",
        value: "image",
        show: true,
        disabled: false,

        align: "left",
      },
      {
        text: "Name",
        value: "name",
        show: true,
        disabled: false,
        align: "left",
      },
      {
        text: "Nic number",
        value: "nic_number",
        show: true,
        align: "left",
        disabled: false,
      },
      {
        text: "Passport number",
        value: "passport_number",
        show: true,
        align: "left",
        disabled: false,
      },
      {
        text: "Address",
        value: "address",
        show: true,
        align: "left",
        disabled: false,
      },
      {
        text: "Mobile",
        value: "phone",
        show: true,
        disabled: true,

        align: "left",
      },
      {
        text: "Company",
        value: "company",
        show: true,
        disabled: true,

        align: "left",
      },

      {
        text: "Status",
        value: "is_active",
        show: true,
        disabled: false,
        align: "center",
      },
      {
        text: "Actions",
        value: "action",
        show: true,
        disabled: true,
        align: "center",
      },
    ],

    customer: [],
    filter: {
      name: "",
      search: "",
      status: "",
    },
  }),
  components: {
    TableFilters,
    ValidationProvider,
    ValidationObserver,
    pagination,
  },

  methods: {
    changeimage(value) {
      this.loadimage = value;
    },
    setPaginationOptions(data) {
      this.paginationOptions = data;
    },
    refreshData() {
      this.$refs.pagination.refreshData();
    },

    setResponseData(customer) {
      this.customer = customer.map((u, i, arr) => {
        u.index = i + 1;
        return new Guest().toViewModal(u);
      });
    },

    getStatusColor(status) {
      return status ? "green" : "gray";
    },

    clearFilter() {
      this.filter = {};
    },
  },
  computed: {
    // Filter - return selected table fields
    headers: function() {
      return this.columns.filter((item) => item.show == true);
    },
  },
};
</script>
